// @flow
import moment from 'moment';

import {
  FILTERS_RESET_DATE_RANGE,
  FILTERS_SET_DATE_RANGE,
  FILTERS_SET_TIME_RANGE,
  FILTERS_SET_ALTITUDE_RANGE,
  FILTERS_SET_IS_SRSS,
  FILTERS_SET_AIRSPACE_USE_TYPE,
} from 'actions/filters';

// NOTE: This *NEEDS* to be done here, otherwise dates won't be localized.
moment.locale('hu');

const INITIAL_STATE = {
  dateRange: { min: moment(), max: moment() },
  timeRange: { min: 360, max: 1080 },
  altitudeRange: { min: 0, max: 1500 },
  airspaceUseType: 'UAV_FLIGHT',
  isSRSS: false,
};

export default function reduce(
  state = INITIAL_STATE,
  { type, range, rangeBound, boundValue, airspaceUseType, isSRSS }
) {
  switch (type) {
    case FILTERS_RESET_DATE_RANGE:
      return {
        ...state,
        dateRange: INITIAL_STATE.dateRange,
      };

    case FILTERS_SET_DATE_RANGE:
      return {
        ...state,
        dateRange: range,
      };

    case FILTERS_SET_TIME_RANGE:
      return {
        ...state,
        timeRange: range,
      };

    case FILTERS_SET_ALTITUDE_RANGE:
      return {
        ...state,
        altitudeRange: {
          ...state.altitudeRange,
          [rangeBound]: parseInt(boundValue, 10) || 0,
        },
      };

    case FILTERS_SET_IS_SRSS:
      return {
        ...state,
        isSRSS,
      };

    case FILTERS_SET_AIRSPACE_USE_TYPE:
      return {
        ...state,
        airspaceUseType,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/filters.js